function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShowRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 6c10 0 14 10 14 10s-4 10-14 10S2 16 2 16 6 6 16 6zm0 2C8.945 8 5.288 13.896 4.206 16.005 5.285 18.133 8.903 24 16 24c7.055 0 10.712-5.896 11.794-8.005C26.716 13.867 23.097 8 16 8zm0 3a5 5 0 110 10 5 5 0 010-10zm0 2c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z",
    fill: props.color
  }));
}

export default SvgIconShowRexOutline;